import React from 'react';

import ItemDetail from '~/components/Details/ItemDetail';
import { IUserProfile } from '~/store/modules/users/types';

import { Items } from './styles';

interface UserInformationItemsProps {
  userProfile: IUserProfile;
}

const UserInformationItems = ({ userProfile }: UserInformationItemsProps) => {
  return (
    <Items>
      <ItemDetail
        className={`${userProfile?.firstName} ${userProfile?.lastName}`}
        label="Nome completo"
        value={`${userProfile?.firstName} ${userProfile?.lastName}`}
      />
      <ItemDetail label="E-mail" value={userProfile?.email} />
      <ItemDetail
        className={
          userProfile?.dynamicAttributes?.emailContact === '' ||
          userProfile.dynamicAttributes === null
            ? 'undefinedItem'
            : ''
        }
        label="E-mail de contato"
        value={
          userProfile?.dynamicAttributes?.emailContact === '' ||
          userProfile.dynamicAttributes === null
            ? 'Não informado'
            : userProfile?.dynamicAttributes?.emailContact
        }
      />
      <ItemDetail
        className={userProfile?.registration === '' ? 'undefinedItem' : ''}
        label="Matrícula"
        value={
          userProfile?.registration === null
            ? 'Não informado'
            : userProfile?.registration
        }
      />
      <ItemDetail
        className={userProfile?.cpf === '' ? 'undefinedItem' : ''}
        label="CPF"
        value={
          userProfile?.cpf === '' || userProfile?.cpf === null
            ? 'Não informado'
            : userProfile?.cpf?.replace(/^(\d{3})(\d{3})(\d{3})/, '$1.$2.$3-')
        }
      />
      <ItemDetail
        className={
          userProfile?.dynamicAttributes?.phone1 === '' ||
          userProfile.dynamicAttributes === null
            ? 'undefinedItem'
            : ''
        }
        label="Telefone 1"
        value={
          userProfile?.dynamicAttributes?.phone1 === '' ||
          userProfile.dynamicAttributes === null
            ? 'Não informado'
            : userProfile?.dynamicAttributes?.phone1?.replace(
                /^(\d{0})(\d{2})(\d{0})(\d{5})/,
                '$1($2)$3 $4-',
              )
        }
      />
      <ItemDetail
        className={
          userProfile?.dynamicAttributes?.phone2 === '' ||
          userProfile.dynamicAttributes === null
            ? 'undefinedItem'
            : ''
        }
        label="Telefone 2"
        value={
          userProfile?.dynamicAttributes?.phone2 === '' ||
          userProfile.dynamicAttributes === null
            ? 'Não informado'
            : userProfile?.dynamicAttributes?.phone2?.replace(
                /^(\d{0})(\d{2})(\d{0})(\d{5})/,
                '$1($2)$3 $4-',
              )
        }
      />
      <ItemDetail
        className={
          userProfile?.dynamicAttributes?.office === '' ||
          userProfile.dynamicAttributes === null
            ? 'undefinedItem'
            : ''
        }
        label="Cargo"
        value={
          userProfile?.dynamicAttributes?.office === '' ||
          userProfile.dynamicAttributes === null
            ? 'Não informado'
            : userProfile?.dynamicAttributes?.office
        }
      />
      <ItemDetail
        className={
          userProfile?.dynamicAttributes?.area === '' ||
          userProfile.dynamicAttributes === null
            ? 'undefinedItem'
            : ''
        }
        label="Área"
        value={
          userProfile?.dynamicAttributes?.area === '' ||
          userProfile.dynamicAttributes === null
            ? 'Não informado'
            : userProfile?.dynamicAttributes?.area
        }
      />
      <ItemDetail
        className={
          userProfile?.dynamicAttributes?.manager === '' ||
          userProfile.dynamicAttributes === null
            ? 'undefinedItem'
            : ''
        }
        label="Gestor"
        value={
          userProfile?.dynamicAttributes?.manager === '' ||
          userProfile.dynamicAttributes === null
            ? 'Não informado'
            : userProfile?.dynamicAttributes?.manager
        }
      />
    </Items>
  );
};

export default UserInformationItems;
